 (function() {


  // ------------- CONFIGURATION OPTIONS -------------- //
  // {
  //   alertType: String - 'success' || 'warn' || 'error' || 'info'
  //   title: String - The title of the alert,
  //   message: String - The message of the alert,
  //   suppressIcon: Boolean (optional) - pass false to hide the icon, otherwise it will show
  //   action: Object - Implementation is TBD
  // }

  var directiveFunction = ['$compile', function($compile) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        scope.$watch("bindHtmlCompile", function(newVal) {
          elem.html('');
            newVal = newVal ? newVal.split('&lt;').join('<').split('&gt;').join('>') : newVal;
          var newElem = angular.element(newVal);
          var compileNewElem = $compile(newElem)(scope.$parent.$parent);
          elem.append(compileNewElem);
        });
      },
      scope: {
        bindHtmlCompile: "="
      }
    }
  }]

  angular.module('cvsApp').directive('bindHtmlCompile', directiveFunction);

})();